<script setup lang="ts">
import { SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/vue-splide/css';
</script>

<template>
  <SplideSlide class="w-full">
    <slot></slot>
  </SplideSlide>
</template>
